import React, { useEffect, useState } from "react";
import Layout from "../components/common/layout/Index";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import { fetchSessions, fetchLots } from "../redux/action/liveAuctionAction";
import { clearLots, handleSelection } from "../redux/slice/liveAuctionSlice";
import RegisterInterestModal from "../components/partials/property-details/right-panel/modals/RegisterInterestModal";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import VerifyAccountModal from "../components/partials/property-details/right-panel/modals/VerifyAccountModal";
import { accountStatus } from "../utils/constants";
import { createSlug } from "../helpers";

export default function LiveAuction() {
    const [accountVerifiedModal, setAccountVerifiedModal] = useState(false);

    const sessions = useSelector((state) => state.liveAuction.sessions);
    const selectedSession = useSelector(
        (state) => state.liveAuction.selectedSession
    );
    const lots = useSelector((state) => state.liveAuction.lots);
    const user = useSelector((state) => state.auth.user);

    const [showRegisterInterestModal, setShowRegisterInterestModal] =
        useState(false);
    const [isRegisteredInterset, setIsRegisteredInterest] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    // ================= SAME LOGIC =================

    const handleRegisterInterestClick = (lot) => {
        // dispatch(handleSelection({ selectedLot: lot }));
        if (!user?.user_id) {
            navigate(`/sign-in?redirect=${location.pathname}`);
        } else {
            setShowRegisterInterestModal(true);
        }
    };

    const onClickBidRegistration = (lot) => {
        dispatch(handleSelection({ selectedLot: lot }));

        if (!user?.user_id) {
            navigate(
                `/sign-in?redirect=${encodeURIComponent(location.pathname)}`
            );
            return;
        }

        if (
            (user?.user_account_verification || user?.is_account_verified) !==
            accountStatus?.success
        ) {
            setAccountVerifiedModal(true);
            return;
        }

        navigate("/bidder-registration", {
            state: {
                propertyId: lot?.property_id,
                depositAmount: lot?.deposit_amount,
                propertyName: lot?.property_name,
                propertyNameAR: lot?.property_name_ar,
                currentPathName: window.location.href,
                propertyAuctionDate: lot?.property_auction_data[0]?.start_date,
                propertyState: lot?.state,
                propertyCommunity: lot?.community,
                propertyCommunityAr: lot?.community_ar,
                selectedSessionID: selectedSession?.id,
            },
        });
    };

    useEffect(() => {
        dispatch(fetchSessions({ page: 1 }));
    }, []);

    return (
        <>
            <Helmet>
                <title>Live Auction</title>
            </Helmet>

            <Layout>
                <div style={styles.container}>
                    {/* ================= SESSIONS ================= */}
                    <div style={styles.sidebar}>
                        <h3>Sessions</h3>

                        <div id="sessionScroll" style={styles.scrollBox}>
                            <InfiniteScroll
                                dataLength={sessions.data.length}
                                next={() => {
                                    if (!sessions.loading) {
                                        dispatch(
                                            fetchSessions({
                                                page: sessions.page + 1,
                                            })
                                        );
                                    }
                                }}
                                hasMore={sessions.page < sessions.totalPage}
                                loader={<p style={styles.loader}>Loading...</p>}
                                scrollableTarget="sessionScroll"
                            >
                                {sessions.data.map((session) => (
                                    <div
                                        key={session.id}
                                        onClick={() => {
                                            dispatch(clearLots());
                                            dispatch(
                                                fetchLots({
                                                    session_id: session.id,
                                                    // page: 1,
                                                })
                                            );
                                            dispatch(
                                                handleSelection({
                                                    selectedSession: session,
                                                })
                                            );
                                        }}
                                        style={{
                                            ...styles.sessionCard,
                                            background:
                                                selectedSession?.id ===
                                                session.id
                                                    ? "#e6f7ff"
                                                    : "#fff",
                                        }}
                                    >
                                        {session.name}
                                    </div>
                                ))}
                            </InfiniteScroll>
                        </div>
                    </div>

                    {/* ================= LOTS ================= */}
                    <div style={styles.middle}>
                        <h3>Lots</h3>

                        <div id="lotScroll" style={styles.scrollBox}>
                            {!selectedSession && (
                                <div style={styles.noData}>
                                    Select a session
                                </div>
                            )}

                            <InfiniteScroll
                                dataLength={lots.data.length}
                                next={() => {
                                    if (!lots.loading && selectedSession) {
                                        dispatch(
                                            fetchLots({
                                                session_id: selectedSession.id,
                                                // page: lots.page + 1,
                                            })
                                        );
                                    }
                                }}
                                hasMore={
                                    selectedSession &&
                                    lots.page < lots.totalPage
                                }
                                loader={<p style={styles.loader}>Loading...</p>}
                                scrollableTarget="lotScroll"
                            >
                                {lots.data.map((lot) => (
                                    <div
                                        key={lot.id}
                                        style={styles.lotCard}
                                        onClick={() =>
                                            navigate(
                                                `/property/detail/${createSlug(lot?.property_id || "", `${lot?.property_name || ""}`)}`
                                            )
                                        }
                                    >
                                        <img
                                            src={`${process.env.REACT_APP_AZURE_BLOB_URL}${lot.cover_image?.[0]?.bucket_name}/${lot.cover_image?.[0]?.doc_file_name}`}
                                            style={styles.image}
                                        />

                                        <div style={{ flex: 1 }}>
                                            <div style={styles.title}>
                                                {lot.lot_unique_id}:{" "}
                                                {lot.property_name}
                                            </div>

                                            <div style={styles.price}>
                                                Starting from AED{" "}
                                                {lot.start_price}
                                            </div>
                                        </div>

                                        <div>
                                            <span style={styles.status}>
                                                {lot.status_name}
                                            </span>
                                        </div>
                                    </div>
                                ))}
                            </InfiniteScroll>
                        </div>
                    </div>

                    {/* ================= RIGHT ACTION PANEL ================= */}
                    {Array.isArray(lots?.data) && !lots?.data.length ? (
                        <></>
                    ) : (
                        <div style={styles.rightPanel}>
                            <h3>Actions</h3>
                            <div style={styles.actionBox}>
                                {/* <div style={styles.actionTitle}>
                                {selectedLot.property_name}
                            </div> */}

                                <div style={styles.actionList}>
                                    <button style={styles.secondaryBtn}>
                                        Live Room Status
                                    </button>

                                    {/* {!selectedLot.is_register_interest && ( */}
                                    <button
                                        style={styles.secondaryBtn}
                                        onClick={() =>
                                            handleRegisterInterestClick()
                                        }
                                    >
                                        Register Interest
                                    </button>
                                    {/* )} */}

                                    {/* {!selectedLot.is_registered && ( */}
                                    <button
                                        style={styles.secondaryBtn}
                                        onClick={() =>
                                            onClickBidRegistration(
                                                lots?.data[0]
                                            )
                                        }
                                    >
                                        Register to Bid
                                    </button>
                                    {/* )} */}

                                    <button
                                        style={styles.secondaryBtn}
                                        onClick={() => {
                                            dispatch(
                                                handleSelection({
                                                    selectedLot: lots?.data[0],
                                                })
                                            );
                                            navigate("/live-auction-details");
                                        }}
                                    >
                                        Join Room
                                    </button>

                                    <button
                                        style={styles.secondaryBtn}
                                        onClick={() => {
                                            dispatch(
                                                handleSelection({
                                                    selectedLot: lots?.data[0],
                                                })
                                            );
                                            navigate("/live-auction-details");
                                        }}
                                    >
                                        Watch
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {/* MODALS SAME */}
                {showRegisterInterestModal && (
                    <RegisterInterestModal
                        show={showRegisterInterestModal}
                        onClose={() => setShowRegisterInterestModal(false)}
                        property={lots.data[0]?.property_id}
                        setIsRegisteredInterest={setIsRegisteredInterest}
                        rememberMeFlag={isRegisteredInterset}
                    />
                )}

                {accountVerifiedModal && (
                    <VerifyAccountModal
                        show={accountVerifiedModal}
                        onClose={() => setAccountVerifiedModal(false)}
                    />
                )}
            </Layout>
        </>
    );
}

const styles = {
    container: {
        display: "flex",
        height: "100vh",
        gap: "20px",
    },

    sidebar: {
        width: "25%",
        padding: "20px",
        borderRight: "1px solid #ddd",
        display: "flex",
        flexDirection: "column",
    },

    middle: {
        width: "50%",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
    },

    scrollBox: {
        flex: 1,
        overflow: "auto",
        border: "1px solid #eee",
        borderRadius: "8px",
        padding: "10px",
        marginTop: "10px",
    },

    sessionCard: {
        padding: "10px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        marginBottom: "10px",
        cursor: "pointer",
    },

    lotCard: {
        position: "relative",
        display: "flex",
        gap: "12px",
        padding: "12px",
        border: "1px solid #ddd",
        borderRadius: "12px",
        marginBottom: "12px",
        alignItems: "center",
        background: "#fff",
        transition: "all 0.25s ease",
    },
    lotCardHover: {
        transform: "translateY(-3px)",
        boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
    },

    actionBtn: {
        padding: "6px 10px",
        border: "1px solid #ccc",
        borderRadius: "4px",
        cursor: "pointer",
        background: "#f8f8f8",
        fontSize: "12px",
    },

    image: {
        width: "80px",
        height: "80px",
        borderRadius: "8px",
        objectFit: "cover",
    },

    title: {
        fontWeight: "600",
        fontSize: "14px",
    },

    price: {
        fontSize: "13px",
        color: "#666",
        marginTop: "4px",
    },
    primaryBtn: {
        padding: "6px 12px",
        background: "#007bff",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        fontSize: "12px",
        fontWeight: "600",
    },

    secondaryBtn: {
        padding: "6px 12px",
        background: "#fff",
        border: "1px solid #ccc",
        borderRadius: "6px",
        cursor: "pointer",
        fontSize: "12px",
    },

    ghostBtn: {
        padding: "6px 12px",
        background: "transparent",
        border: "1px solid #ccc",
        borderRadius: "6px",
        cursor: "pointer",
        fontSize: "12px",
    },
    hoverActions: {
        position: "absolute",
        top: "50%",
        right: "12px",
        transform: "translateY(-50%)",
        display: "flex",
        gap: "8px",
        background: "#fff",
        padding: "6px 8px",
        borderRadius: "8px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        zIndex: 999,
        whiteSpace: "nowrap",
    },
    metaRow: {
        display: "flex",
        gap: "10px",
        fontSize: "12px",
        marginTop: "6px",
    },

    status: {
        background: "#d4edda",
        padding: "4px 8px",
        borderRadius: "6px",
        fontSize: "12px",
    },

    loader: {
        textAlign: "center",
        padding: "10px",
        color: "#888",
    },

    noData: {
        padding: "20px",
        textAlign: "center",
        color: "#888",
        border: "1px dashed #ddd",
        borderRadius: "8px",
        marginTop: "10px",
    },
    rightPanel: {
        width: "25%",
        padding: "20px",
        borderLeft: "1px solid #ddd",
    },

    actionBox: {
        border: "1px solid #eee",
        borderRadius: "12px",
        padding: "16px",
        marginTop: "10px",
        background: "#fff",
        position: "sticky",
        top: "20px",
    },

    actionTitle: {
        fontWeight: "600",
        marginBottom: "10px",
    },

    actionList: {
        display: "flex",
        flexDirection: "column",
        gap: "10px",
    },
};
